import { Model } from '@vuex-orm/core'
import Language from './Language'
import Question from './Question'
import Team from './Team'

export default class Questionnaire extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'questionnaire'

  static primaryKey = '_id'

  // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
  // The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      customer: this.attr(null),
      title: this.attr([
        new Language('en'),
        new Language('de')
      ]),
      triggerAfter: this.attr({
        value: 12,
        type: 'hours'
      }),
      timing: this.attr({
        time: '',
        repeatEvery: {count: 1, type: null},
        repeatAt: {count: 1, type: []}
      }),
      teams: this.hasMany(Team, '_id'),
      questions: this.hasMany(Question, '_id'),
      locked: this.attr(false),
      createdAt: this.attr('')
    }
  }

  static defaults (langs) {
    return Object.assign(this, {
      title: langs.map( lang => new Language(lang) ),
      triggerAfter: {
        value: 12,
        type: 'hours'
      },
      timing: new Timing()
    })
  }

  static apiConfig = {}
}

export class Timing {
  constructor () {
    this.time = ''
    this.repeatEvery = {count: 1, type: null}
    this.repeatAt = {count: 1, type: []}
  }
}
